(function ($) {
  "use strict";

  var koksvanner = {
    init: function () {
      this.mainMenuBlock();
      this.mainMenuBlock1();
      this.submenuOpener();
      this.fixedHeader();
      this.produstsSlider();
      this.fullWidthSlider();
      this.hideShowButton();
      this.filterOpener();
      this.singleProductSlider();
      this.hotSpot();
      this.inspirationSlider();
    },

    mainMenuBlock: function () {
      jQuery("header").on("click", ".navbar-toggle-btn", function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
          jQuery("#navbar").removeClass("active");
          jQuery("html").removeClass("menu-active");
          jQuery(this).removeClass("nav-close").addClass("nav-open");
        } else {
          jQuery("#navbar").addClass("active");
          jQuery("html").addClass("menu-active");
          jQuery(this).removeClass("nav-open").addClass("nav-close");
        }
      });
    },

    mainMenuBlock1: function () {
      jQuery("header").on(
        "click",
        ".navbar-toggle-btn.nav-close",
        function (e) {
          jQuery("html").removeClass("submenu-active");
          jQuery(".nav-item").removeClass("opened");
          jQuery(".submenu-opener").removeClass("closed");
          jQuery(".dropdown-menu").css("display", "none");
        }
      );
    },

    submenuOpener: function () {
      jQuery("header.main-header .navbar-nav .submenu-opener").on(
        "click",
        function (e) {
          // e.preventDefault();
          jQuery("html").toggleClass("submenu-active");

          if (!jQuery(this).hasClass("closed")) {
            jQuery(this).addClass("closed");
            jQuery(this).parent(".nav-item").addClass("opened");
            jQuery(this).next(".dropdown-menu").slideToggle();
          } else {
            jQuery(this).removeClass("closed");
            jQuery(this).parent(".nav-item").removeClass("opened");
            jQuery(this).next(".dropdown-menu").slideToggle();
          }
        }
      );
    },

    fixedHeader: function () {
      jQuery(function () {
        function toggleStickyHeader() {
          var sticky = jQuery("header"),
            scroll = jQuery(window).scrollTop();

          if (scroll >= 1) {
            sticky.addClass("sticky-header");
          } else {
            sticky.removeClass("sticky-header");
          }
        }

        jQuery(window).on("scroll", toggleStickyHeader);
        toggleStickyHeader(); // Trigger once on page load
      });
    },



    produstsSlider: function () {
      $('.products-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        responsive: [

          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      });

    },

    fullWidthSlider: function () {
      $('.full-width-slider').slick({
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true
      });

      jQuery(".full-width-slider .left-arrow").click(function () {
        jQuery(".full-width-slider .slick-prev ").trigger("click");
        return false;
      });

      jQuery(".full-width-slider .right-arrow").click(function () {
        jQuery(".full-width-slider .slick-next").trigger("click");
        return false;
      });

    },

    hideShowButton: function () {
      $(".hide-show-btn").bind("click", function (event) {
        event.preventDefault();
        $(this).closest('.content-box').find(".hidden-contents").slideToggle('500', 'linear');
        $(this).closest('.content-box').find(".social-block").slideToggle('500', 'linear');
        $(this).toggleClass("hide");
      });
    },

    filterOpener: function () {
      jQuery(".filter-block .trigger-btn").on("click", function () {
        $(".filter-block .trigger-btn").not(this).removeClass("show");
        $(this).toggleClass("show");
      });

      // jQuery(".filter-block .single-checkbox input").change(function () {
      //   jQuery(".single-filter-block .trigger-btn").removeClass("show");
      // });
    },

    singleProductSlider: function () {

      jQuery(".single-product-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        adaptiveHeight: false,
        asNavFor: ".single-product-thumbnail-slider",
        infinite: true,
      });
      jQuery(".single-product-thumbnail-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".single-product-slider",
        focusOnSelect: true,
        arrows: true,
        infinite: true,
        prevArrow: '<button class="slick-prev theme-btn rounded-btn has-arrow left-arrow"></button>',
        nextArrow: '<button class="slick-next theme-btn rounded-btn has-arrow right-arrow"></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });


    },

    inspirationSlider: function () {

      jQuery(document).ready(function () {
        var $mainSlider = jQuery(".inspiration-slider");
        var $leftArrow = jQuery(".inspiration-slider-block .left-arrow");
        var $rightArrow = jQuery(".inspiration-slider-block .right-arrow");

        // Initialize slider
        $mainSlider.on("init", function () {
          updateArrowStates(); // ← Add disabled class on load
        });

        // After each slide change, update custom arrow states
        $mainSlider.on("afterChange", function () {
          updateArrowStates();
        });

        // Left arrow click
        $leftArrow.click(function () {
          var $prev = $mainSlider.find(".slick-prev");

          if (!$prev.hasClass("slick-disabled")) {
            $prev.trigger("click");
          }

          updateArrowStates();
          return false;
        });

        // Right arrow click
        $rightArrow.click(function () {
          var $next = $mainSlider.find(".slick-next");

          if (!$next.hasClass("slick-disabled")) {
            $next.trigger("click");
          }

          updateArrowStates();
          return false;
        });

        // Initialize the Slick slider (make sure to place this after the above handlers)
        $mainSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          adaptiveHeight: false,
          asNavFor: ".inspiration-thumbnail-slider",
          infinite: true,
          speed: 0,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                fade: true,
                speed: 300,
              },
            }
          ],
        });

        // Sync custom arrows with Slick arrows
        function updateArrowStates() {
          var $prev = $mainSlider.find(".slick-prev");
          var $next = $mainSlider.find(".slick-next");

          $leftArrow.toggleClass("slick-disabled", $prev.hasClass("slick-disabled"));
          $rightArrow.toggleClass("slick-disabled", $next.hasClass("slick-disabled"));
        }
      });


      jQuery(".inspiration-thumbnail-slider").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: ".inspiration-slider",
        focusOnSelect: true,
        arrows: false,
        infinite: true,
        //  accesibility: false,
        // draggable: false,
        // swipe: false,
        // touchMove: false,
        // swipeToSlide: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

    },

    hotSpot: function () {
      document.addEventListener('DOMContentLoaded', function () {
        const hotspots = document.querySelectorAll('.single-hotspot');

        hotspots.forEach(hotspot => {
          const toggle = hotspot.querySelector('.hotspot');
          const balloon = hotspot.querySelector('.balloon');

          toggle.addEventListener('click', function (e) {
            e.stopPropagation();

            // Close all other balloons
            document.querySelectorAll('.single-hotspot').forEach(otherHotspot => {
              if (otherHotspot !== hotspot) {
                const otherBalloon = otherHotspot.querySelector('.balloon');
                otherBalloon.style.display = 'none';
                otherHotspot.classList.remove('show');
              }
            });

            // Toggle current balloon
            if (balloon.style.display === 'block') {
              balloon.style.display = 'none';
              hotspot.classList.remove('show');
            } else {
              balloon.style.display = 'block';
              hotspot.classList.add('show');
              adjustBalloonPosition(hotspot);
            }
          });
        });

        // Hide balloons when clicking outside
        document.addEventListener('click', function () {
          document.querySelectorAll('.single-hotspot').forEach(hotspot => {
            hotspot.querySelector('.balloon').style.display = 'none';
            hotspot.classList.remove('show');
          });
        });

        // Recalculate positions on resize
        window.addEventListener('resize', function () {
          document.querySelectorAll('.single-hotspot.show').forEach(hotspot => {
            adjustBalloonPosition(hotspot);
          });
        });

        function adjustBalloonPosition(hotspot) {
          const balloon = hotspot.querySelector('.balloon');
          const parent = hotspot.closest('.single-img');
          if (!balloon || !parent) return;

          // Reset styles
          balloon.style.left = '50%';
          balloon.style.right = 'auto';
          balloon.style.transform = 'translateX(-50%)';

          // Show temporarily to measure
          balloon.style.display = 'block';

          const balloonRect = balloon.getBoundingClientRect();
          const parentRect = parent.getBoundingClientRect();
          const hotspotRect = hotspot.getBoundingClientRect();

          const overflowLeft = parentRect.left - balloonRect.left;
          const overflowRight = balloonRect.right - parentRect.right;

          if (overflowLeft > 0) {
            const offset = hotspotRect.left - parentRect.left;
            balloon.style.left = `-${offset}px`;
            balloon.style.transform = 'none';
          } else if (overflowRight > 0) {
            const offset = parentRect.right - hotspotRect.left;
            balloon.style.left = 'auto';
            balloon.style.right = `-${offset - 15}px`; // <-- Added 15px offset here
            balloon.style.transform = 'none';
          }
        }
      });
    },

  };

  koksvanner.init();
})(jQuery);


